module.exports = __webpack_public_path__ + "static/media/bfile-motorcycle.287fb09b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-motorcycle.svg
// module id = 172
// module chunks = 0